import { render, staticRenderFns } from "./khlb.vue?vue&type=template&id=5139e013&scoped=true&"
import script from "./khlb.vue?vue&type=script&lang=js&"
export * from "./khlb.vue?vue&type=script&lang=js&"
import style0 from "./khlb.vue?vue&type=style&index=0&id=5139e013&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139e013",
  null
  
)

export default component.exports